(function () {
  function initDesktopMegamenus() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var nav = header.querySelector('.aceites-header__nav');
    if (!nav) return;

    var items = Array.prototype.slice.call(nav.querySelectorAll('.aceites-header__menu-item--has-mega'));
    if (!items.length) return;

    var activeItem = null;
    var closeTimer = null;

    function isDesktop() {
      return window.matchMedia('(min-width: 769px)').matches;
    }

    function setExpanded(item, expanded) {
      var trigger = item && item.querySelector(':scope > .aceites-header__menu-link');
      if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function close(item) {
      if (!item) return;
      item.classList.remove('is-open');
      setExpanded(item, false);
      if (activeItem === item) activeItem = null;
    }

    function closeAll(except) {
      items.forEach(function (item) {
        if (item !== except) close(item);
      });
    }

    function open(item) {
      if (!isDesktop()) return;
      window.clearTimeout(closeTimer);
      closeAll(item);
      item.classList.add('is-open');
      setExpanded(item, true);
      activeItem = item;
    }

    function scheduleClose(item, trigger, panel) {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        var pointerIsInside = trigger.matches(':hover') || panel.matches(':hover');
        if (!pointerIsInside && !item.contains(document.activeElement)) close(item);
      }, 260);
    }

    items.forEach(function (item) {
      var trigger = item.querySelector(':scope > .aceites-header__menu-link');
      var panel = item.querySelector(':scope > .aceites-header__megamenu');
      if (!trigger || !panel) return;

      /* La activación pertenece sólo al enlace. Escuchar pointerenter en el
         <li> también incluye la geometría del megamenú absoluto y hacía que
         zonas situadas bajo otros enlaces pudieran abrir este submenú. */
      trigger.addEventListener('pointerenter', function () { open(item); });
      trigger.addEventListener('pointerleave', function () { scheduleClose(item, trigger, panel); });
      panel.addEventListener('pointerenter', function () {
        window.clearTimeout(closeTimer);
        if (activeItem === item) open(item);
      });
      panel.addEventListener('pointerleave', function () { scheduleClose(item, trigger, panel); });
      item.addEventListener('focusin', function () { open(item); });
      item.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement)) close(item);
        }, 0);
      });
    });

    Array.prototype.slice.call(nav.querySelectorAll('.aceites-header__menu-item:not(.aceites-header__menu-item--has-mega) > .aceites-header__menu-link'))
      .forEach(function (link) {
        link.addEventListener('pointerenter', function () { closeAll(); });
      });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && activeItem) {
        var trigger = activeItem.querySelector(':scope > .aceites-header__menu-link');
        closeAll();
        if (trigger) trigger.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (!isDesktop()) closeAll();
    });
  }

  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    var header = menu.closest('[data-header]');

    var toggleTriggers = document.querySelectorAll('[data-mobile-menu-toggle]');
    var closeTriggers = menu.querySelectorAll('[data-mobile-menu-close]');
    var views = menu.querySelectorAll('[data-menu-view]');
    var openButtons = menu.querySelectorAll('[data-menu-open]');
    var backButtons = menu.querySelectorAll('[data-menu-back]');

    function setView(name) {
      views.forEach(function (view) {
        var match = view.getAttribute('data-menu-view') === name;
        view.classList.toggle('is-active', match);
        view.hidden = !match;
      });
    }

    function open() {
      menu.setAttribute('aria-hidden', 'false');
      if (header) header.classList.add('is-menu-open');
      document.body.style.overflow = 'hidden';
      toggleTriggers.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
    }
    function close() {
      menu.setAttribute('aria-hidden', 'true');
      if (header) header.classList.remove('is-menu-open');
      document.body.style.overflow = '';
      toggleTriggers.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      // Reset a la vista raíz al cerrar
      setView('root');
    }
    function toggle() {
      var isOpen = menu.getAttribute('aria-hidden') === 'false';
      if (isOpen) close(); else open();
    }

    toggleTriggers.forEach(function (btn) { btn.addEventListener('click', toggle); });
    closeTriggers.forEach(function (btn) { btn.addEventListener('click', close); });

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setView(btn.getAttribute('data-menu-open'));
      });
    });
    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { setView('root'); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* Toggle de la posición del header — con hero visible queda más bajo,
     al hacer scroll se sube. Threshold configurable via data-stuck-threshold. */
  function initStickyState() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var threshold = parseInt(header.getAttribute('data-stuck-threshold') || '24', 10);
    var raf = null;

    function update() {
      raf = null;
      var scrolled = window.scrollY > threshold;
      header.classList.toggle('is-stuck', scrolled);
    }

    function onScroll() {
      if (raf !== null) return;
      raf = window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  /* Panel/modal del buscador con predictive search renderizado vía sección.
     - Desktop: dropdown bajo la pill.
     - Móvil: full-screen modal animado con barra de búsqueda propia + load more.
     Sync entre el input de la pill y el del modal. */
  function initSearchPanel() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var form = header.querySelector('.aceites-header__search');
    var pillInput = header.querySelector('.aceites-header__search-input');
    var pillBtn = header.querySelector('.aceites-header__search-btn');
    var panel = header.querySelector('[data-search-panel]');
    if (!form || !panel) return;

    var modalInput = panel.querySelector('[data-search-modal-input]');
    var modalForm = panel.querySelector('[data-search-modal-form]');
    var closeBtn = panel.querySelector('[data-search-close]');
    var resultsList = panel.querySelector('[data-search-results]');
    var loadMoreBtn = panel.querySelector('[data-search-load-more]');
    var defaultResultsHTML = resultsList ? resultsList.innerHTML : '';
    var baseLimit = parseInt(panel.getAttribute('data-search-limit'), 10) || 8;
    var loadStep = parseInt(panel.getAttribute('data-search-load-step'), 10) || 8;
    var currentLimit = baseLimit;
    var debounceTimer = null;
    var lastQuery = '';
    var lastTotal = 0;

    function isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }

    function open() {
      panel.hidden = false;
      // wait a tick so transitions kick in
      window.requestAnimationFrame(function () {
        header.classList.add('is-search-open');
        document.body.classList.toggle('has-search-open', isMobile());
        if (isMobile() && modalInput) modalInput.focus();
      });
    }

    function close() {
      header.classList.remove('is-search-open');
      document.body.classList.remove('has-search-open');
      // hide after animation
      window.setTimeout(function () { panel.hidden = true; }, 220);
    }

    function syncInputs(value, source) {
      if (pillInput && source !== pillInput) pillInput.value = value;
      if (modalInput && source !== modalInput) modalInput.value = value;
    }

    function restoreDefaults() {
      if (resultsList) resultsList.innerHTML = defaultResultsHTML;
      panel.classList.remove('is-searching');
      if (loadMoreBtn) loadMoreBtn.hidden = true;
      currentLimit = baseLimit;
      lastTotal = 0;
    }

    function setLoading(loading) {
      panel.classList.toggle('is-loading', loading);
    }

    async function fetchResults(q, limit) {
      var url = '/search/suggest'
        + '?q=' + encodeURIComponent(q)
        + '&section_id=predictive-search'
        + '&resources[type]=product'
        + '&resources[limit]=' + limit
        + '&resources[options][unavailable_products]=last';
      var res = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error('search_failed');
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-search-results]');
      return fresh;
    }

    async function search(q, options) {
      options = options || {};
      var append = !!options.append;

      if (!q) {
        restoreDefaults();
        return;
      }

      panel.classList.add('is-searching');
      setLoading(true);

      try {
        var fresh = await fetchResults(q, currentLimit);
        if (q !== lastQuery && !append) return; // outdated
        if (resultsList && fresh) {
          resultsList.innerHTML = fresh.innerHTML;
          var count = resultsList.querySelectorAll('.aceites-header__search-product').length;
          // Si pedimos más y obtenemos lo mismo, ocultar load more
          if (loadMoreBtn) {
            loadMoreBtn.hidden = (count < currentLimit) || (count === lastTotal);
          }
          lastTotal = count;
        }
      } catch (e) { /* noop */ }
      finally { setLoading(false); }
    }

    function debouncedSearch(q) {
      lastQuery = q;
      if (debounceTimer) window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () { search(q); }, 200);
    }

    function onInput(e) {
      var q = e.target.value.trim();
      syncInputs(q, e.target);
      currentLimit = baseLimit;
      lastTotal = 0;
      debouncedSearch(q);
    }

    /* --- listeners --- */
    if (pillInput) {
      pillInput.addEventListener('focus', function () { if (!isMobile()) open(); });
      pillInput.addEventListener('click', function () { if (!isMobile()) open(); });
      pillInput.addEventListener('input', onInput);
    }
    if (modalInput) {
      modalInput.addEventListener('input', onInput);
    }

    /* En móvil el botón lupa de la pill abre el modal en vez de submit.
       Cada apertura empieza desde cero: limpia los inputs y restaura los
       resultados por defecto. */
    if (pillBtn) {
      pillBtn.addEventListener('click', function (e) {
        if (!isMobile()) return;
        e.preventDefault();
        syncInputs('', null);
        lastQuery = '';
        currentLimit = baseLimit;
        lastTotal = 0;
        if (debounceTimer) {
          window.clearTimeout(debounceTimer);
          debounceTimer = null;
        }
        restoreDefaults();
        open();
      });
    }

    /* Sugerencias populares */
    panel.querySelectorAll('[data-search-suggestion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.getAttribute('data-search-suggestion') || '';
        syncInputs(q, null);
        lastQuery = q;
        currentLimit = baseLimit;
        lastTotal = 0;
        search(q);
        if (modalInput && isMobile()) modalInput.focus();
        else if (pillInput) pillInput.focus();
      });
    });

    /* Cerrar — botón × del modal, click fuera, Escape */
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (form.contains(e.target) || panel.contains(e.target)) return;
      if (!isMobile()) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        close();
        if (pillInput) pillInput.blur();
        if (modalInput) modalInput.blur();
      }
    });

    /* Evitar /search en cualquier submit */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      search((pillInput && pillInput.value || '').trim());
    });
    if (modalForm) {
      modalForm.addEventListener('submit', function (e) {
        e.preventDefault();
        search((modalInput && modalInput.value || '').trim());
      });
    }

    /* Cargar más — re-fetch con limit mayor */
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        if (!lastQuery) return;
        currentLimit += loadStep;
        search(lastQuery, { append: true });
      });
    }
  }

  function init() {
    initDesktopMegamenus();
    initMobileMenu();
    initStickyState();
    initSearchPanel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
